/**
 * Get an array of classes that should be applied based on the classMap
 * definition
 *
 * @example
 * const classMap = {
 *   default: "brk-hello-world-root",
 *   modifierPrefix: "brk-hello-world",
 *   modifiers: [
 *     {
 *       condition: aTruthyValue,
 *       className: "full-width",
 *     },
 *     {
 *       condition: aFalsyValue,
 *       className: "on-dark",
 *     },
 *   ],
 * };
 *
 * getClassList(classMap); // returns ["brk-hello-world-root", "brk-hello-world--full-width"]
 */
function getClassList(classMap) {
    const classList = [];
    if (classMap.default) {
        classList.push(classMap.default);
    }
    const getClass = (modifierPrefix, className) => (modifierPrefix ? `${modifierPrefix}--${className}` : className);
    return classMap.modifiers.reduce((acc, modifierClass) => {
        if (!modifierClass.condition) {
            return acc;
        }
        // Prefer the modifier class' modiferPrefix over the default if it exists
        const modifierPrefix = typeof modifierClass.modifierPrefix !== "undefined"
            ? modifierClass.modifierPrefix
            : classMap.modifierPrefix;
        // Handle an array of modifier classes
        if (Array.isArray(modifierClass.className)) {
            const modifierClasses = modifierClass.className.map((className) => getClass(modifierPrefix, className));
            return acc.concat(modifierClasses);
        }
        acc.push(getClass(modifierPrefix, modifierClass.className));
        return acc;
    }, classList);
}

export { getClassList as default };
//# sourceMappingURL=get-class-list.js.map
